module.exports = __webpack_public_path__ + "./img/stock-medium.5563b9bb14d4bf05ac667aa5941d84d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stock-medium.png
// module id = ./src/assets/img/stock-medium.png
// module chunks = 11